import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef, OnChanges
} from '@angular/core';
import { uniqBy } from 'lodash';
import { Itab } from '@ispm/shared/interfaces/Itab';

@Component({
  selector: 'gen-tabs-header',
  templateUrl: './tabs-header.component.html',
  styleUrls: ['./tabs-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsHeaderComponent implements OnInit, OnChanges {

  _tabs: Itab[];
  get tabs(): Itab[] {
    return this._tabs;
  }
  @Input() set tabs(tabs: Itab[]) {
    this._tabs = uniqBy(tabs, 'name')
      .map((tab, idx) => ({
        ...tab,
        id: tab.id || tab.name,
      }));
  }
  @Input() currentTab: string;
  @Input() styleModifier: string = '';
  @Input() isCloseable: boolean = false;
  @Input() disabled: boolean = false;
  @Output() tabChange: EventEmitter<string> = new EventEmitter();
  @Output() tabInit: EventEmitter<string> = new EventEmitter();
  @Output() tabClose: EventEmitter<string> = new EventEmitter();

  constructor(
    private cd: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    if (!this.currentTab && this.tabs && this.tabs.length > 0) {
      this.currentTab = this.tabs[0].name;
      this.cd.markForCheck();
      this.cd.detectChanges();
      this.tabInit.emit(this.currentTab);
    }
  }

  onTabChange(tabName: string) {
    if ( this.currentTab === tabName || this.disabled) {
      return;
    }

    this.currentTab = tabName;
    this.tabChange.emit(tabName);
  }

  ngOnChanges() {
    this.cd.markForCheck();
    this.cd.detectChanges();
  }

  closeTab(tabName: string) {
    this.tabClose.emit(tabName);
  }

  public trackById(index, item: Itab) {
    return item.id;
  }
}
